// FollowUpTasks.js
import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { FaChevronDown } from "react-icons/fa";
import { Menu, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CreateFollowUpMd from "../../../../components/Header/modals/CreateFollowUpMd";
import {
  fetchFollowUpTasks,
  setOpenAllFollowUp,
} from "../../../../redux/slices/MsgSlice";

const FollowUpTasks = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenu, setCurrentMenu] = useState(false);
  const [openCreateModal, setCreateModal] = useState(false);
  const { selectedConvo } = useSelector((state) => state.messages);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setCurrentMenu(false);
  };
  const openCreate = () => {
    setCreateModal(true);
    handleClose();
  };
  const openAllFollows = () => {
    dispatch(setOpenAllFollowUp(true));
    dispatch(fetchFollowUpTasks(selectedConvo.Id));
    handleClose();
  };

  return (
    <div className="wc-chat-drop">
      <Button
        className="drop-button"
        style={{
          backgroundColor: "#01a2e8",
          color: "black",
          fontSize: "small",
        }}
        size="sm"
        onClick={handleClick}
      >
        <span className="drop-button-title">
          Follow Up Tasks
          <FaChevronDown size={10} />
        </span>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={currentMenu}
        onClose={handleClose}
        PaperProps={{
          style: {
            minWidth: "120px",
            maxWidth: "200px",
          },
        }}
      >
        <MenuItem onClick={openAllFollows}>View Tasks</MenuItem>
        <MenuItem onClick={openCreate}>Add Task</MenuItem>
      </Menu>
      {openCreateModal && (
        <CreateFollowUpMd
          open={openCreateModal}
          handleClose={() => setCreateModal(false)}
          selectedConvo={selectedConvo}
        />
      )}
    </div>
  );
};

export default FollowUpTasks;
